import { Grid, GridItem, Text, useViewport } from '@farmersdog/corgi-x';
import { LegalLinks } from './LegalLinks';

import styles from './LegalDetails.module.css';

export const LegalDetails = () => {
  const viewport = useViewport();
  const isMobile = !viewport.lg;

  return (
    <Grid gap="lg">
      <GridItem lg={6} className={styles.copyrightContainer}>
        <Text variant="heading-16">
          © {new Date().getFullYear()} The Farmer’s Dog, Inc.
        </Text>
        <Text variant="heading-16">Long Live Dogs™</Text>
      </GridItem>
      <GridItem lg={6} justifyContent={isMobile ? 'flex-start' : 'flex-end'}>
        <LegalLinks />
      </GridItem>
    </Grid>
  );
};
